import React from "react";

export default function SimpleLoading() {
  return (
    <div className="bg-gray-100 w-full h-[50vh] flex justify-center items-center rounded-md">
      <div className="text-sm font-medium text-gray-700">Harap Tunggu...</div>
    </div>
  );
}
